<!-- =========================================================================================
    File Name: StatisticsCard.vue
    Description: Statistics card component
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <vx-card class="overflow-hidden">
      <div slot="no-body">
         <!-- Header -->
        <div class="vx-card__header">
            <div class="vx-card__title">
              <h4>{{ $t(i18n) || title }}</h4>
            </div>
            <div class="vx-card__actions">
              <div class="vx-card__action-buttons">
                <feather-icon v-if="enableZoomIn" @click="zoomIn" icon="SearchIcon" svgClasses="h-6 w-6" class="ml-4" />
                <feather-icon v-if="enableDrilling" @click="drillTo" icon="CornerRightDownIcon" svgClasses="h-6 w-6" class="ml-4"/>
              </div>
            </div>
        </div>
        <!-- Chart -->
        <div>
          <vue-apex-charts type="radialBar" height="175" :options="chartOptions" :series="chartData" />
        </div>
      </div>
      <!-- Footer -->
      <div class="flex justify-between text-center mt-5" slot="no-body-bottom">
        <div class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0 border-l-0">
          <p class="mt-4">{{ $t(leftDataTitlei18n) || leftDataTitle }}</p>
          <p class="mb-4 text-3xl font-semibold">{{ formattedLeftData}}</p>
        </div>
        <div class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0">
          <p class="mt-4">{{ $t(rightDataTitlei18n) || rightDataTitle }}</p>
          <p class="mb-4 text-3xl font-semibold">{{ formattedRightData }}</p>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import chartConfigs from './chartConfigs.js'
import shared from '@/filters/shared.js'

export default {
  props: {
    title: {
      type: String
    },
    i18n : {
      type: String
    },
    linkTo: {
      type: String
    },
    leftDataTitle: {
      type: String
    },
    leftDataTitlei18n: {
      type: String
    },
    leftDataValue: {
    },
    dataFilter: {
      type: String
    },
    rightDataTitle: {
      type: String
    },
    rightDataTitlei18n: {
      type: String
    },
    rightDataValue: {
    },
    enableZoomIn: {
      type: Boolean,
      default: false
    },
    chartData: {
      // type: Array,
      // required: true
    }
  },
  
  computed : {
    formattedLeftData() {
      return shared.formatValue(this.leftDataValue, this.dataFilter, this);
    },
    formattedRightData() {
      return shared.formatValue(this.rightDataValue, this.dataFilter, this);
    },
    enableDrilling() {
      return this.linkTo !== "" && typeof this.linkTo !== 'undefined';
    }
  },
  data () {
    return {
      chartOptions: null
    }
  },
  components: {
    VueApexCharts
  },
  created () {
    this.chartOptions = Object.assign({}, chartConfigs.radialBarChartOptions)
  },
  methods: {
    zoomIn() {
      this.$emit("onZoomIn");
    },
    drillTo() {
      this.$emit("onDrillTo", this.linkTo);
    }
  }
}
</script>
